import {AjaxForm, cookieHelper, FormsApi} from '@shopify/marketing-assets';

export function ExpertsMarketplaceEmailSignupForm() {
  const form = document.querySelector('.js-migration-toolkit-signup-form');

  if (form) {
    const userTokenEl = document.getElementById('guide-user-token');
    if (userTokenEl) {
      userTokenEl.value = cookieHelper.get('_shopify_y');
    }

    const sessionTokenEl = document.getElementById('guide-session-token');
    if (sessionTokenEl) {
      sessionTokenEl.value = cookieHelper.get('_shopify_s');
    }

    new AjaxForm(form, [
      {
        name: 'email',
        fn: FormsApi.validateEmail,
      },
      {
        name: 'company_name',
        fn: (value) => {
          const errors = {};
          if (value.length > 1500) {
            errors.length = true;
          }
          return errors;
        },
      },
    ],
      {
        json: true,
        onSuccess: () => {
          return window.location.assign(form.getAttribute('data-redirect-path'));
        },
      });
  }
}

(() => new ExpertsMarketplaceEmailSignupForm())();
